(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"), require("@material/chips/dist/mdc.chips.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js", "@material/chips/dist/mdc.chips.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"), require("@material/chips/dist/mdc.chips.js")) : factory(root["react"], root["classnames"], root["@material/react-ripple/dist/index.js"], root["@material/chips/dist/mdc.chips.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_11__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 24);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
      /***/
    },,,,,,,,,
    /* 3 */

    /* 4 */

    /* 5 */

    /* 6 */

    /* 7 */

    /* 8 */

    /* 9 */

    /* 10 */

    /* 11 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
      /***/
    },
    /* 12 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var _extendStatics = function extendStatics(d, b) {
          _extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return _extendStatics(d, b);
        };

        return function (d, b) {
          _extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var ChipCheckmark =
      /** @class */
      function (_super) {
        __extends(ChipCheckmark, _super);

        function ChipCheckmark() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.width = 0;

          _this.init = function (element) {
            if (!element) {
              return;
            } // The checkmark's width may initially be set to 0, so use the checkmark's height as a proxy since the
            // checkmark should always be square.


            _this.width = element.getBoundingClientRect().height;
          };

          return _this;
        }

        ChipCheckmark.prototype.render = function () {
          return React.createElement("div", {
            className: 'mdc-chip__checkmark',
            ref: this.init
          }, React.createElement("svg", {
            className: 'mdc-chip__checkmark-svg',
            viewBox: '-2 -3 30 30',
            focusable: 'false'
          }, React.createElement("path", {
            className: 'mdc-chip__checkmark-path',
            fill: 'none',
            stroke: 'black',
            d: 'M1.73,12.91 8.1,19.28 22.79,4.59'
          })));
        };

        return ChipCheckmark;
      }(React.Component);

      exports.default = ChipCheckmark;
      /***/
    },,,,,,,,,,,,
    /* 13 */

    /* 14 */

    /* 15 */

    /* 16 */

    /* 17 */

    /* 18 */

    /* 19 */

    /* 20 */

    /* 21 */

    /* 22 */

    /* 23 */

    /* 24 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var Chip_1 = __webpack_require__(25);

      exports.Chip = Chip_1.default;

      var ChipCheckmark_1 = __webpack_require__(12);

      exports.ChipCheckmark = ChipCheckmark_1.default;

      var ChipSet_1 = __webpack_require__(26);

      exports.ChipSet = ChipSet_1.default;
      /***/
    },
    /* 25 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var _extendStatics2 = function extendStatics(d, b) {
          _extendStatics2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return _extendStatics2(d, b);
        };

        return function (d, b) {
          _extendStatics2(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var __assign = this && this.__assign || function () {
        __assign = Object.assign || function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];

            for (var p in s) {
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
          }

          return t;
        };

        return __assign.apply(this, arguments);
      };

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1);

      var Ripple = __webpack_require__(2); // @ts-ignore no mdc .d.ts file


      var mdc_chips_1 = __webpack_require__(11);

      ;

      var Chip =
      /** @class */
      function (_super) {
        __extends(Chip, _super);

        function Chip() {
          var _this = _super !== null && _super.apply(this, arguments) || this;

          _this.chipElement = null;
          _this.state = {
            classList: new Set(),
            leadingIconClassList: new Set()
          };

          _this.init = function (el) {
            _this.chipElement = el;
            _this.props.initRipple && _this.props.initRipple(el);
          };

          _this.onClick = function (e) {
            _this.props.onClick(e);

            _this.foundation.handleInteraction(e);
          };

          _this.onKeyDown = function (e) {
            _this.props.onKeyDown(e);

            _this.foundation.handleInteraction(e);
          };

          _this.handleTrailingIconClick = function (e) {
            return _this.foundation.handleTrailingIconInteraction(e);
          };

          _this.handleTransitionEnd = function (e) {
            _this.props.onTransitionEnd(e);

            _this.foundation.handleTransitionEnd(e);
          };

          _this.renderLeadingIcon = function (leadingIcon) {
            var leadingIconClassList = _this.state.leadingIconClassList;

            var _a = leadingIcon.props,
                className = _a.className,
                otherProps = __rest(_a, ["className"]);

            var props = __assign({
              className: classnames_1.default(className, Array.from(leadingIconClassList), 'mdc-chip__icon', 'mdc-chip__icon--leading')
            }, otherProps);

            return React.cloneElement(leadingIcon, props);
          };

          _this.renderTrailingIcon = function (trailingIcon) {
            var _a = trailingIcon.props,
                className = _a.className,
                otherProps = __rest(_a, ["className"]);

            var props = __assign({
              className: classnames_1.default(className, 'mdc-chip__icon', 'mdc-chip__icon--trailing'),
              onClick: _this.handleTrailingIconClick,
              onKeyDown: _this.handleTrailingIconClick,
              tabIndex: 0,
              role: 'button'
            }, otherProps);

            return React.cloneElement(trailingIcon, props);
          };

          return _this;
        }

        Chip.prototype.componentDidMount = function () {
          var _a = this.props,
              selected = _a.selected,
              shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick;
          this.foundation = new mdc_chips_1.MDCChipFoundation(this.adapter);
          this.foundation.init();
          this.foundation.setSelected(selected);

          if (shouldRemoveOnTrailingIconClick !== this.foundation.getShouldRemoveOnTrailingIconClick()) {
            this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemoveOnTrailingIconClick);
          }
        };

        Chip.prototype.componentDidUpdate = function (prevProps) {
          var _a = this.props,
              selected = _a.selected,
              shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick;

          if (selected !== prevProps.selected) {
            this.foundation.setSelected(selected);
          }

          if (shouldRemoveOnTrailingIconClick !== prevProps.shouldRemoveOnTrailingIconClick) {
            this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemoveOnTrailingIconClick);
          }
        };

        Chip.prototype.componentWillUnmount = function () {
          this.foundation.destroy();
        };

        Object.defineProperty(Chip.prototype, "classes", {
          get: function get() {
            var classList = this.state.classList;
            var className = this.props.className;
            return classnames_1.default('mdc-chip', Array.from(classList), className);
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(Chip.prototype, "adapter", {
          get: function get() {
            var _this = this;

            return {
              addClass: function addClass(className) {
                var classList = new Set(_this.state.classList);
                classList.add(className);

                _this.setState({
                  classList: classList
                });
              },
              removeClass: function removeClass(className) {
                var classList = new Set(_this.state.classList);
                classList.delete(className);

                _this.setState({
                  classList: classList
                });
              },
              hasClass: function hasClass(className) {
                return _this.classes.split(' ').includes(className);
              },
              eventTargetHasClass: function eventTargetHasClass(target, className) {
                return target.classList.contains(className);
              },
              getComputedStyleValue: function getComputedStyleValue(propertyName) {
                if (!_this.chipElement) return;
                return window.getComputedStyle(_this.chipElement).getPropertyValue(propertyName);
              },
              setStyleProperty: function setStyleProperty(propertyName, value) {
                if (!_this.chipElement) return;

                _this.chipElement.style.setProperty(propertyName, value);
              },
              notifyRemoval: function notifyRemoval() {
                return _this.props.handleRemove(_this.props.id);
              },
              notifyInteraction: function notifyInteraction() {
                return _this.props.handleInteraction(_this.props.id);
              },
              notifySelection: function notifySelection(selected) {
                return _this.props.handleSelect(_this.props.id, selected);
              },
              notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                return _this.props.handleTrailingIconInteraction(_this.props.id);
              },
              addClassToLeadingIcon: function addClassToLeadingIcon(className) {
                var leadingIconClassList = new Set(_this.state.leadingIconClassList);
                leadingIconClassList.add(className);

                _this.setState({
                  leadingIconClassList: leadingIconClassList
                });
              },
              removeClassFromLeadingIcon: function removeClassFromLeadingIcon(className) {
                var leadingIconClassList = new Set(_this.state.leadingIconClassList);
                leadingIconClassList.delete(className);

                _this.setState({
                  leadingIconClassList: leadingIconClassList
                });
              }
            };
          },
          enumerable: true,
          configurable: true
        });

        Chip.prototype.render = function () {
          var _a = this.props,

          /* eslint-disable no-unused-vars */
          id = _a.id,
              className = _a.className,
              selected = _a.selected,
              handleSelect = _a.handleSelect,
              handleInteraction = _a.handleInteraction,
              handleRemove = _a.handleRemove,
              handleTrailingIconInteraction = _a.handleTrailingIconInteraction,
              onClick = _a.onClick,
              onKeyDown = _a.onKeyDown,
              onTransitionEnd = _a.onTransitionEnd,
              computeBoundingRect = _a.computeBoundingRect,
              initRipple = _a.initRipple,
              unbounded = _a.unbounded,
              shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick,

          /* eslint-enable no-unused-vars */
          chipCheckmark = _a.chipCheckmark,
              leadingIcon = _a.leadingIcon,
              trailingIcon = _a.trailingIcon,
              label = _a.label,
              otherProps = __rest(_a, ["id", "className", "selected", "handleSelect", "handleInteraction", "handleRemove", "handleTrailingIconInteraction", "onClick", "onKeyDown", "onTransitionEnd", "computeBoundingRect", "initRipple", "unbounded", "shouldRemoveOnTrailingIconClick", "chipCheckmark", "leadingIcon", "trailingIcon", "label"]);

          return React.createElement("div", __assign({
            tabIndex: 0,
            className: this.classes,
            onClick: this.onClick,
            onKeyDown: this.onKeyDown,
            onTransitionEnd: this.handleTransitionEnd,
            ref: this.init
          }, otherProps), leadingIcon && this.renderLeadingIcon(leadingIcon), chipCheckmark, React.createElement("div", {
            className: 'mdc-chip__text'
          }, label), trailingIcon && this.renderTrailingIcon(trailingIcon));
        };

        Chip.defaultProps = {
          id: '',
          label: '',
          className: '',
          selected: false,
          onClick: function onClick() {},
          onKeyDown: function onKeyDown() {},
          onTransitionEnd: function onTransitionEnd() {},
          initRipple: function initRipple() {},
          handleSelect: function handleSelect() {},
          handleRemove: function handleRemove() {},
          handleInteraction: function handleInteraction() {},
          handleTrailingIconInteraction: function handleTrailingIconInteraction() {},
          shouldRemoveOnTrailingIconClick: true
        };
        return Chip;
      }(React.Component);

      exports.Chip = Chip;
      exports.default = Ripple.withRipple(Chip);
      /***/
    },
    /* 26 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var __extends = this && this.__extends || function () {
        var _extendStatics3 = function extendStatics(d, b) {
          _extendStatics3 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return _extendStatics3(d, b);
        };

        return function (d, b) {
          _extendStatics3(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();

      var __rest = this && this.__rest || function (s, e) {
        var t = {};

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        }

        if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
        }
        return t;
      };

      Object.defineProperty(exports, "__esModule", {
        value: true
      }); // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.

      var React = __webpack_require__(0);

      var classnames_1 = __webpack_require__(1); // @ts-ignore no mdc .d.ts file


      var mdc_chips_1 = __webpack_require__(11);

      var ChipCheckmark_1 = __webpack_require__(12);

      ;
      ;

      var ChipSet =
      /** @class */
      function (_super) {
        __extends(ChipSet, _super);

        function ChipSet(props) {
          var _this = _super.call(this, props) || this;

          _this.checkmarkWidth = 0;

          _this.handleInteraction = function (chipId) {
            _this.state.foundation.handleChipInteraction(chipId);
          };

          _this.handleSelect = function (chipId, selected) {
            _this.state.foundation.handleChipSelection(chipId, selected);
          };

          _this.handleRemove = function (chipId) {
            _this.state.foundation.handleChipRemoval(chipId);
          };

          _this.removeChip = function (chipId) {
            var _a = _this.props,
                updateChips = _a.updateChips,
                children = _a.children;
            if (!children) return;
            var chips = React.Children.toArray(children).slice();

            for (var i = 0; i < chips.length; i++) {
              var chip = chips[i];

              if (chip.props.id === chipId) {
                chips.splice(i, 1);
                break;
              }
            }

            var chipsArray = chips.length ? chips.map(function (chip) {
              return chip.props;
            }) : [];
            updateChips(chipsArray);
          };

          _this.setCheckmarkWidth = function (checkmark) {
            if (!!_this.checkmarkWidth || !checkmark) {
              return;
            }

            _this.checkmarkWidth = checkmark.width;
          };

          _this.computeBoundingRect = function (chipElement) {
            var _a = chipElement.getBoundingClientRect(),
                height = _a.height,
                chipWidth = _a.width;

            var width = chipWidth + _this.checkmarkWidth;
            return {
              height: height,
              width: width
            };
          };

          _this.renderChip = function (chip) {
            var _a = _this.props,
                choice = _a.choice,
                filter = _a.filter,
                input = _a.input;

            if ((choice || filter || input) && !chip.props.id) {
              throw new Error('Chip variant missing required property: id.');
            }

            var selectedChipIds = _this.state.selectedChipIds;
            var selected = selectedChipIds.indexOf(chip.props.id) > -1;

            var _b = chip.props,
                _handleInteraction = _b.handleInteraction,
                _handleSelect = _b.handleSelect,
                _handleRemove = _b.handleRemove,
                chipProps = __rest(_b, ["handleInteraction", "handleSelect", "handleRemove"]);

            var props = Object.assign.apply(Object, [{}].concat(chipProps, [{
              selected: selected,
              handleSelect: function handleSelect(id, selected) {
                _handleSelect(id, selected);

                _this.handleSelect(id, selected);
              },
              handleInteraction: function handleInteraction(id) {
                _handleInteraction(id);

                _this.handleInteraction(id);
              },
              handleRemove: function handleRemove(id) {
                _handleRemove(id);

                _this.handleRemove(id);
              },
              chipCheckmark: filter ? React.createElement(ChipCheckmark_1.default, {
                ref: _this.setCheckmarkWidth
              }) : null,
              computeBoundingRect: filter ? _this.computeBoundingRect : null
            }]));
            return React.cloneElement(chip, props);
          };

          _this.state = {
            selectedChipIds: props.selectedChipIds,
            foundation: null,
            hasInitialized: false
          };
          return _this;
        }

        ChipSet.prototype.componentDidMount = function () {
          var foundation = new mdc_chips_1.MDCChipSetFoundation(this.adapter);
          this.setState({
            foundation: foundation
          });
          foundation.init();
        };

        ChipSet.prototype.componentDidUpdate = function (prevProps, prevState) {
          var selectedChipIds = this.props.selectedChipIds;

          if (this.state.foundation !== prevState.foundation) {
            this.initChipSelection();
          }

          if (selectedChipIds !== prevProps.selectedChipIds) {
            this.setState({
              selectedChipIds: selectedChipIds
            });
          }
        };

        ChipSet.prototype.componentWillUnmount = function () {
          this.state.foundation.destroy();
        };

        Object.defineProperty(ChipSet.prototype, "classes", {
          get: function get() {
            var _a = this.props,
                className = _a.className,
                filter = _a.filter,
                choice = _a.choice,
                input = _a.input;
            return classnames_1.default('mdc-chip-set', className, {
              'mdc-chip-set--filter': filter,
              'mdc-chip-set--choice': choice,
              'mdc-chip-set--input': input
            });
          },
          enumerable: true,
          configurable: true
        });
        Object.defineProperty(ChipSet.prototype, "adapter", {
          get: function get() {
            var _this = this;

            return {
              hasClass: function hasClass(className) {
                return _this.classes.split(' ').includes(className);
              },
              setSelected: function setSelected() {
                var selectedChipIds = _this.state.foundation.getSelectedChipIds().slice();

                _this.setState({
                  selectedChipIds: selectedChipIds
                }, function () {
                  _this.props.handleSelect(selectedChipIds);
                });
              },
              removeChip: this.removeChip
            };
          },
          enumerable: true,
          configurable: true
        });

        ChipSet.prototype.initChipSelection = function () {
          var _this = this;

          React.Children.forEach(this.props.children, function (child) {
            var id = child.props.id;
            var selected = _this.state.selectedChipIds.indexOf(id) > -1;

            if (selected) {
              _this.state.foundation.select(id);
            }
          });
          this.setState({
            hasInitialized: true
          });
        };

        ChipSet.prototype.render = function () {
          // need foundation on state, because Chip calls a foundation method
          // before ChipSet mounts.
          if (!this.state.hasInitialized) return null;
          return React.createElement("div", {
            className: this.classes
          }, React.Children.map(this.props.children, this.renderChip));
        };

        ChipSet.defaultProps = {
          className: '',
          selectedChipIds: [],
          handleSelect: function handleSelect() {},
          updateChips: function updateChips() {},
          choice: false,
          filter: false,
          input: false
        };
        return ChipSet;
      }(React.Component);

      exports.default = ChipSet;
      /***/
    }])
  );
});